import type {FC} from 'react'
import type React from 'react'
import {clsx} from 'clsx'
import type {Rule} from '@github-ui/repos-rules-types/rules-types'
import {RuleModalState} from '@github-ui/repos-rules-types/rules-types'
import {Blankslate} from './Blankslate'
import styles from './BorderBox.module.css'

type BorderBoxProps = {
  name?: React.ReactNode
  rows?: Rule[]
  condensed?: boolean
  showHeader?: boolean
  groupByPattern?: boolean
  renderCreateButton?(): void
  renderRow?(row: Rule): React.ReactElement
  renderBlankslate?(): React.ReactElement
  children?: React.ReactNode
  className?: string
  headerClassName?: string
}

export const BorderBox: FC<BorderBoxProps> = ({
  name,
  rows,
  condensed,
  showHeader,
  renderCreateButton,
  renderRow,
  renderBlankslate,
  children,
  className,
  headerClassName,
  ...rest
}) => {
  const showBlankslate =
    rows && (rows?.length === 0 || rows.every(({_modalState}) => _modalState === RuleModalState.CREATING))

  return (
    <div className={clsx('Box', className)} {...rest}>
      {!showBlankslate && showHeader ? (
        <div
          className={clsx(
            'Box-header d-flex flex-justify-between flex-items-center pt-2 pb-2 pr-2',
            condensed && styles.condensed,
            headerClassName,
          )}
        >
          <h2 className="Box-title f5">{name}</h2>
          {renderCreateButton?.() || null}
        </div>
      ) : null}
      {rows && renderRow ? (
        <>
          <ul>
            {rows.map(row => (
              <li
                className={clsx(
                  'Box-row d-flex position-relative',
                  condensed && styles.condensed,
                  row._modalState === RuleModalState.CREATING && styles.creating,
                )}
                key={row.id || row._id}
              >
                <div className="d-flex flex-1 width-fit">{renderRow(row)}</div>
              </li>
            ))}
          </ul>
          {showBlankslate ? (
            <Blankslate heading={`No rules have been added yet`}>{renderBlankslate?.()}</Blankslate>
          ) : null}
        </>
      ) : (
        children
      )}
    </div>
  )
}
